import { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from '../i18n';
import NavBarNB from './NavBarNB';
import FooterNB from './FooterNB';

interface LegalPageProps {
  title: string;
  lastUpdated: string;
  children: ReactNode;
}

export default function LegalPage({ title, lastUpdated, children }: LegalPageProps) {
  const { language } = useTranslation();

  return (
    <div className="min-h-screen flex flex-col bg-nb-cream">
      <NavBarNB />

      <main className="flex-1 max-w-3xl mx-auto px-4 py-12 md:py-16 w-full">
        <h1 className="text-3xl md:text-4xl font-bold text-nb-black font-nb mb-2">{title}</h1>
        <p className="text-sm text-nb-text-muted mb-8">{lastUpdated}</p>
        <div className="max-w-none prose prose-sm text-nb-black">
          {children}
        </div>
      </main>

      <FooterNB />
    </div>
  );
}
